import { useDateFormatter } from "@/hooks/useDateFormatter";
import type { RateDiagnostics } from "@/types/exchange-rates";
import { estimateReason } from "../estimate-reasons";

interface Props {
  diagnostics: RateDiagnostics;
}

export const RateCoverage = ({ diagnostics }: Props) => {
  const { formatDate } = useDateFormatter();
  return (
    <section className="rounded-lg border bg-white p-5" aria-label="Valuation diagnostics">
      <h2 className="font-semibold">Valuation context</h2>
      <p>Selected FX source: {diagnostics.selected_fx_source}</p>
      <p>
        Estimate valuation date: {diagnostics.valuation_date ? formatDate(diagnostics.valuation_date) : "Unavailable"}
      </p>
      <p>Confirmed spend watermark: {diagnostics.data_as_of ? formatDate(diagnostics.data_as_of) : "Unavailable"}</p>
      <p className="text-sm text-gray-500">{diagnostics.valuation_basis}</p>
      {diagnostics.uncovered_currencies.length ? (
        <p className="mt-2 text-amber-800">
          Rates do not cover the valuation date for: {diagnostics.uncovered_currencies.join(", ")}. These gaps do not
          block a valid future import.
        </p>
      ) : null}
      {diagnostics.reasons.map(reason => (
        <p key={reason}>{estimateReason(reason)}</p>
      ))}
    </section>
  );
};
